// extracted by mini-css-extract-plugin
module.exports = {"popper":"ShopTimeSlot_popper__tYObN","buttons-wrapper":"ShopTimeSlot_buttons-wrapper__1KiMT","add":"ShopTimeSlot_add__1EPFY"};